import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["state", "shouldRegisterItem", "getItem"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useContext, useRef } from 'react';
import { useSafeLayoutEffect, useForkRef } from 'ariakit-utils/hooks';
import { useStore } from 'ariakit-utils/store';
import { createHook, createComponent, createElement } from 'ariakit-utils/system';
import { C as CollectionItemContext } from '../__utils-4a897e71.js';

function identity(value) {
  return value;
}
/**
 * A component hook that returns props that can be passed to `Role` or any other
 * Ariakit component. This hook will register the item in the collection state.
 * If this hook is used in a component that is wrapped by `Collection` or a
 * component that implements `useCollection`, there's no need to explicitly pass
 * the `state` prop.
 * @see https://ariakit.org/components/collection
 * @example
 * ```jsx
 * const state = useCollectionState();
 * const props = useCollectionItem({ state });
 * <Role {...props}>Item</Role>
 * ```
 */


var useCollectionItem = createHook(function (_ref) {
  var _state;

  var state = _ref.state,
      _ref$shouldRegisterIt = _ref.shouldRegisterItem,
      shouldRegisterItem = _ref$shouldRegisterIt === void 0 ? true : _ref$shouldRegisterIt,
      _ref$getItem = _ref.getItem,
      getItem = _ref$getItem === void 0 ? identity : _ref$getItem,
      props = _objectWithoutProperties(_ref, _excluded);

  state = useStore(state, ["registerItem"]);
  var contextRegisterItem = useContext(CollectionItemContext);
  var registerItem = ((_state = state) == null ? void 0 : _state.registerItem) || contextRegisterItem;
  var ref = useRef(null);
  useSafeLayoutEffect(function () {
    if (!shouldRegisterItem) return;
    return registerItem == null ? void 0 : registerItem(getItem({
      ref: ref
    }));
  }, [shouldRegisterItem, getItem, registerItem]);
  props = _objectSpread(_objectSpread({}, props), {}, {
    ref: useForkRef(ref, props.ref)
  });
  return props;
});
/**
 * A component that renders an item in a collection. The collection state can be
 * passed explicitly through the `state` prop or implicitly through the
 * `Collection` component.
 * @see https://ariakit.org/components/collection
 * @example
 * ```jsx
 * const state = useCollectionState();
 * <CollectionItem state={state}>Item 1</CollectionItem>
 * <CollectionItem state={state}>Item 2</CollectionItem>
 * <CollectionItem state={state}>Item 3</CollectionItem>
 * ```
 */

var CollectionItem = createComponent(function (props) {
  var htmlProps = useCollectionItem(props);
  return createElement("div", htmlProps);
});
export { CollectionItem, useCollectionItem };